import Clear from "@mui/icons-material/Clear";
import Search from "@mui/icons-material/Search";
import { Box, ClickAwayListener, IconButton, InputAdornment, TextField } from "@mui/material";
import { useCallback, useState } from "react";

interface ExpandableSearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  width?: number;
}

export function ExpandableSearchInput({
  value,
  onChange,
  placeholder = "Search",
  width = 220,
}: ExpandableSearchInputProps) {
  const [open, setOpen] = useState(false);

  const handleClear = useCallback(() => {
    onChange("");
    setOpen(false);
  }, [onChange]);

  return (
    <ClickAwayListener
      onClickAway={() => {
        if (!value) setOpen(false);
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-end",
          width: open ? width : 32,
          transition: "width 200ms ease-in-out",
          overflow: "hidden",
          py: "1px",
        }}
      >
        {open ? (
          <TextField
            variant="outlined"
            size="small"
            placeholder={placeholder}
            value={value}
            onChange={(e) => onChange(e.target.value)}
            inputRef={(input) => {
              if (input && open) input.focus();
            }}
            sx={{ width, flexShrink: 0 }}
            slotProps={{
              input: {
                sx: { height: 32, fontSize: "0.875rem", pr: 0.5 },
                endAdornment: (
                  <InputAdornment position="end" sx={{ mr: 0 }}>
                    <IconButton
                      size="small"
                      sx={{ width: 32, height: 32 }}
                      onClick={handleClear}
                      aria-label="clear search"
                      edge="end"
                    >
                      {value ? <Clear fontSize="small" /> : <Search fontSize="small" />}
                    </IconButton>
                  </InputAdornment>
                ),
              },
            }}
          />
        ) : (
          <IconButton
            size="small"
            onClick={() => setOpen(true)}
            sx={{ width: 32, height: 32, mr: "1px" }}
          >
            <Search fontSize="small" />
          </IconButton>
        )}
      </Box>
    </ClickAwayListener>
  );
}
